/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import useEmployeeHealthcheckService from 'domain/people/employee/Timeline/healthcheck/employeeHealthcheckService';
import { CreateForm, AfterSubmitProps } from 'framework/form';
import { BaseTimelineItemFormLayout } from 'framework/ui/timeline';
import HealthcheckForm from './HealthcheckForm';

interface CreateHealthcheckFormProps {
  onCancel: () => void;
  messageContext: any;
  afterSubmit?: AfterSubmitProps<(response: any) => any, string | ((response: any) => any)>;
}

// messageContext and afterSubmit we're passing directly(not as ...props) to NOT override submitFormFunc which is custom from useEmployeeHealthcheckService
const CreateHealthcheckForm = ({ onCancel, messageContext, afterSubmit }: CreateHealthcheckFormProps) => {
  const { getValidationSchema, create } = useEmployeeHealthcheckService();

  return (
    <CreateForm
      submitFormFunc={create}
      getValidationSchemaFunc={getValidationSchema}
      messageContext={messageContext}
      afterSubmit={afterSubmit}
    >
      <BaseTimelineItemFormLayout isCreateForm onCancel={onCancel}>
        <HealthcheckForm />
      </BaseTimelineItemFormLayout>
    </CreateForm>
  );
};

export default CreateHealthcheckForm;
